<script>
import {Message} from "element-ui";
import {addOrUpdateSensorType, delSensorType, sensorTypeList} from "@/api/system";
import SensorTrigger from "@/components/SensorTrigger.vue";

export default {
  name: 'SensorTypeDrawer',
  components: {SensorTrigger},
  data() {
    return {
      visible: false,
      systemId : null,
      current : 1,
      pageSize: 10,
      total : 0,
      sensorTypes: [],
      // 表单数据
      form: {
        id: null,
        name: '',
        unit: '',
        code: '',
        mainTitle: '',
        subTitle: '',
        orderNum: 0
      },
      // 表单弹窗可见性
      formVisible: false,
      // 表单标题
      formTitle: '新增传感器类型',
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: '请输入传感器名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入传感器编码', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        orderNum: [
          { type: 'number', required: true, message: '请输入排序号', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
  },
  methods: {

    handleOpen(systemId) {
      if (!systemId){
        Message.error('系统id丢失')
         return;
      }
      this.systemId = systemId;
      this.visible = true
      this.fetchList();
    },
    handleClose() {
      this.visible = false
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.current = 1;
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.current = val;
      this.fetchList()
    },
    clearList(){
      this.current = 1
      this.officeList = []
    },
    async fetchList(){
      const param = {
        current : this.current,
        size : this.pageSize,
        filter : [
            {
              name : 'systemTypeId',
              value : this.systemId,
              type : 'EQ'
            }
        ],
        sorted : [
            {
              name : 'orderNum',
              type : 'ASC'
            }
        ],
      }
      const resp = await sensorTypeList(param);
      if (resp && resp.code === '0000'){
        this.sensorTypes = resp.result.records;
        this.total = resp.result.total;
      }
    },

    // 打开新增表单
    openAddForm() {
      this.formTitle = '新增传感器类型';
      this.form = {
        id: null,
        name: '',
        unit: '',
        code: '',
        mainTitle: '',
        subTitle: '',
        orderNum: 0
      };
      this.formVisible = true;
    },

    // 打开编辑表单
    openEditForm(row) {
      this.formTitle = '编辑传感器类型';
      this.form = {
        id: row.id,
        name: row.name || '',
        unit: row.unit || '',
        code: row.code || '',
        mainTitle: row.mainTitle || '',
        subTitle: row.subTitle || '',
        orderNum: row.orderNum || 0
      };
      this.formVisible = true;
    },


    openTrigger(row) {
      this.$refs.sensorTriggerRef.handleTypeOpen(row.id)
    },

    // 关闭表单弹窗
    closeForm() {
      this.formVisible = false;
    },

    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            // 构造提交参数
            const param = {
              ...this.form,
              systemTypeId: this.systemId
            };

            console.log('提交参数:', param);

            const resp = await addOrUpdateSensorType(param);
            if (resp && resp.code === '0000' && resp.result) {
              Message.success('保存成功');
              this.fetchList();
            }else {
              Message.error('操作失败');
            }
          } catch (error) {
            console.error('保存失败:', error);
            Message.error('保存失败');
          }finally {
            this.formVisible = false;
          }
        }
      });
    },

    // 删除传感器类型
    deleteSensorType(row) {
      this.$confirm('此操作将永久删除该传感器类型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const resp = await delSensorType(row.id);
          if (resp && resp.code === '0000') {
            Message.success('删除成功');
            this.fetchList();
          }
        } catch (error) {
          console.error('删除失败:', error);
          Message.error('删除失败');
        }
      }).catch(() => {
        // 用户取消删除
      });
    }
  }
}

</script>

<template>
  <div>
    <el-drawer
        title="传感器类型"
        :visible.sync="visible"
        direction="btt"
        size="80vh"
        :with-header="false"
    >
      <el-card shadow="never">
        <!-- 新增按钮 -->
        <div style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
          <el-button type="primary" size="small" @click="openAddForm">新增传感器类型</el-button>
        </div>

        <el-table :data="sensorTypes" border stripe highlight-current-row>
          <el-table-column prop="name" label="传感器名称" />
          <el-table-column prop="unit" label="传感器单位" />
          <el-table-column prop="code" label="传感器编码" />
          <el-table-column prop="mainTitle" label="主标题" />
          <el-table-column prop="subTitle" label="副标题" />
          <el-table-column prop="orderNum" label="传感器排序" />
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="openEditForm(scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="openTrigger(scope.row)">触发规则</el-button>
              <el-button size="mini" type="text" @click="deleteSensorType(scope.row)" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div style="display: flex; justify-content: flex-end; width: 100%; margin-top: 16px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="current" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total"
                         class="pagination"></el-pagination>
        </div>
      </el-card>
    </el-drawer>

    <!-- 新增/编辑表单弹窗 -->
    <el-dialog :title="formTitle" :visible.sync="formVisible" width="400px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="传感器名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入传感器名称" />
        </el-form-item>
        <el-form-item label="传感器单位" prop="unit">
          <el-input v-model="form.unit" placeholder="请输入传感器单位" />
        </el-form-item>
        <el-form-item label="传感器编码" prop="code">
          <el-input v-model="form.code" placeholder="请输入传感器编码" />
        </el-form-item>
        <el-form-item label="主标题" prop="mainTitle">
          <el-input v-model="form.mainTitle" placeholder="请输入主标题" />
        </el-form-item>
        <el-form-item label="副标题" prop="subTitle">
          <el-input v-model="form.subTitle" placeholder="请输入副标题" />
        </el-form-item>
        <el-form-item label="传感器排序" prop="orderNum">
          <el-input-number v-model="form.orderNum" placeholder="请输入排序号" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <SensorTrigger ref="sensorTriggerRef" />
  </div>

</template>

<style scoped>

</style>
